module.exports = __webpack_public_path__ + "static/feature3Desktop-1540bb3a2d6bae054673319119c25b3b.mp4";